import React from 'react'

function NearYouSection() {
  return (
      <div className="widget widget-estate">
          <h3 className="widget-title title-news">Proches de vous</h3>
          <ul className="group-estate flex">
              <li className="box-estate hover-img2">
                  <div className="thumb img-style2 ">
                      <img
                          className="img2" 
                          src="/assets/images/img-box/sidebar-estate-1.jpg"
                          alt="images"
                      />
                  </div>
                  <div className="content">
                      <div className="title link-style-3 fw-6 lh-18">
                          <a href="/link">Moncton</a>{" "}
                      </div>
                      <p className="fs-12 lh-16 text-color-1">
                          13km de chez vous
                      </p>
                  </div>
              </li>
              <li className="box-estate hover-img2">
                  <div className="thumb img-style2 ">
                      <img
                          className="img2"
                          src="/assets/images/img-box/sidebar-estate-2.jpg"
                          alt="images"
                      />
                  </div>
                  <div className="content">
                      <div className="title link-style-3 fw-6 lh-18">
                          <a href="/link">Mississauga</a>{" "}
                      </div>
                      <p className="fs-12 lh-16 text-color-1">
                          13km de chez vous
                      </p>
                  </div>
              </li>
              <li className="box-estate hover-img2">
                  <div className="thumb img-style2 ">
                      <img
                          className="img2"
                          src="/assets/images/img-box/sidebar-estate-3.jpg"
                          alt="images"
                      />
                  </div>
                  <div className="content">
                      <div className="title link-style-3 fw-6 lh-18">
                          <a href="/link">Halifax</a>{" "}
                      </div>
                      <p className="fs-12 lh-16 text-color-1">
                          13km de chez vous
                      </p>
                  </div>
              </li>
              <li className="box-estate hover-img2">
                  <div className="thumb img-style2 ">
                      <img
                          className="img2"
                          src="/assets/images/img-box/sidebar-estate-4.jpg"
                          alt="images"
                      />
                  </div>
                  <div className="content">
                      <div className="title link-style-3 fw-6 lh-18">
                          <a href="/link">Ottawa</a>{" "}
                      </div>
                      <p className="fs-12 lh-16 text-color-1">
                          13km de chez vous
                      </p>
                  </div>
              </li>
              <li className="box-estate hover-img2">
                  <div className="thumb img-style2 ">
                      <img
                          className="img2"
                          src="/assets/images/img-box/sidebar-estate-5.jpg"
                          alt="images"
                      />
                  </div>
                  <div className="content">
                      <div className="title link-style-3 fw-6 lh-18">
                          <a href="/link">Iqaluit</a>{" "}
                      </div>
                      <p className="fs-12 lh-16 text-color-1">
                          13km de chez vous
                      </p>
                  </div>
              </li>
              <li className="box-estate hover-img2">
                  <div className="thumb img-style2 ">
                      <img
                          className="img2"
                          src="/assets/images/img-box/sidebar-estate-6.jpg"
                          alt="images"
                      />
                  </div>
                  <div className="content">
                      <div className="title link-style-3 fw-6 lh-18">
                          <a href="/link">Toronto</a>{" "}
                      </div>
                      <p className="fs-12 lh-16 text-color-1">
                          13km de chez vous
                      </p>
                  </div>
              </li>
          </ul>
      </div>
  )
}

export default NearYouSection